import { IGMSDashboardServices } from './gmsdashboard.types'
import { http } from '@/shared/https'

export class GMSDashboardService implements IGMSDashboardServices {

    getInternalDashboard(): any {
        return http.get(`/api/Dashboard/Internal`).then((resp: any) => {
            return resp;
        });
    }

    getExternalDashboard(): any {
        return http.get(`/api/Dashboard/External`).then((resp: any) => {
            return resp;
        });
    }
}